<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :handelAdd="showAddModal"
      :collection="formCollection"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
      :ableAdd="ableAdd"
    ></search-form>
    <a-modal
      width="700px"
      v-model:open="open"
      :title="(isEdit ? '编辑' : '新增') + pageName"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :keyboard="false"
      class="action-form-model"
    >
      <action
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :disabled="disabled"
        :canEdit="canEdit"
        :submitBtn="!disabled"
        :data="tableData"
        :idField="idField"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{ x: 'max-content' }"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'visit_area'">
          {{ codeToText(record.visit_area, Enum.areaType.value) }}
        </template>
        <template v-if="column.key === 'visitor_type'">
          {{ codeToText(record?.visitor_type, Enum.personVisitType.value) }}
        </template>
        <template v-if="column.key === 'visitor_gender'">
          {{ record.visitor_gender === 0 ? '男' : '女' }}
        </template>
        <template v-if="column.key === 'visitor_begin_time'">
          {{ record.visit_begin_time }} 至 {{ record.visit_end_time }}
        </template>
        <template v-if="column.key === 'interviewee_depart_id'">
          {{ codeToText(record.interviewee_depart_id, Enum.dept.value) }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showDetailModal(record)"
              :loading="loadingRecord === record[idField] + 'detail'"
            >
              详情
            </a-button>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record[idField] + 'edit'"
              v-if="
                ableEdit && (record.state === 0 || record.state === 3 || record.state === 4)
              "
            >
              编辑
            </a-button>
            <a-button
              v-if="ableAdd"
              @click="showCopyModal(record)"
              :loading="loadingRecord === record[idField] + 'copy'"
            >
              复制
            </a-button>
            <!--<a-button
              @click="showExtension(record)"
              v-if="record.state === 2"
              @success="fetch()"
            >
              延期申请
            </a-button>-->
            <a-button
              @click="showApprovalProcess(record)"
              :loading="loadingRecord === record[idField] + 'process'"
              v-if="record.state !== 0"
            >
              审批流程
            </a-button>
            <a-popconfirm
              title="确认提交？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="pushRow(record)"
              v-if="ableCommit && record.state === 0"
            >
              <a-button>提交</a-button>
            </a-popconfirm>
            <a-button
              @click="showRevokeModal(record)"
              v-if="ableRevoke && (record.state === 1 || record.state === 2)"
              :loading="loadingRecord === record[idField] + 'revoke'"
              danger
            >撤销审批</a-button>
            <a-popconfirm
              v-if="ableDelete && (record.state !== 1 && record.state !== 2)"
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
    <approval_process
      v-model:openModal="approvalProcessOpen"
      :data="approvalProcessData"
    ></approval_process>
    <extension_application
      ref="extensionRef"
      url="personApplications"
    ></extension_application>

    <a-modal v-model:open="revokeModalOpen" title="是否撤销审批？">
      <a-form :model="revokeModalData" ref="revokeModalFormRef" :rules="revokeModalRules">
        <a-form-item label="撤销理由" name="reason">
          <a-textarea v-model:value="revokeModalData.reason" placeholder="请输入撤销理由" />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button @click="revokeModalOpen = false">取消</a-button>
        <a-button type="primary" @click="revokeRow">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    deleteData,
    getDetail,
    pushData,
    revoke,
    approvalProcess,
  } from '@/api/person_application/person_application'
  import action from './action'
  import { message } from 'ant-design-vue'
  import { codeToText } from '@/utils/format'
  import searchForm from '@/components/search_form'
  import dayjs from 'dayjs'
  import approval_process from '@/components/approval_process'
  import extension_application from '@/components/extension_application'

  //初始化
  const pageName = '园区企业预约申请'
  const idField = 'person_application_id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personApply:list')
  )
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personApply:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personApply:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personApply:delete')
  )
  const ableCommit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personApply:commit')
  )
  const ableRevoke = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personApply:revoke')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'application_id',
      label: '预约单号',
    },
    {
      type: 'input',
      field: 'visitor_name',
      label: '访客姓名',
      width: '110px',
    },
    {
      type: 'input',
      field: 'visitor_idcard',
      label: '访客证件号码',
    },
    {
      type: 'input',
      field: 'visitor_phone',
      label: '访客联系电话',
    },
    {
      type: 'input',
      field: 'interviewee_name',
      label: '被访人员姓名',
    },
    {
      type: 'input',
      field: 'interviewee_phone',
      label: '被访人联系号码',
    },
    {
      type: 'select',
      field: 'application_type',
      label: '申请类型',
      storeOptions: 'personVisitType',
      width: '110px',
      'allow-clear': true,
    },
    {
      type: 'input',
      field: 'visitor_company',
      label: '来访单位',
    },
    {
      type: 'select',
      field: 'status',
      storeOptions: 'status',
      defaultValue: -1,
      label: '审核状态',
      width: '130px',
    },
    {
      type: 'select',
      field: 'visit_area',
      storeOptions: 'areaType',
      //defaultValue: 1,
      label: '访问区域',
      width: '130px',
      'allow-clear': true,
    },
    /*{
      type: 'select',
      field: 'is_delayed',
      storeOptions: 'delayedType',
      defaultValue: -1,
      label: '延期申请',
      width: '100px',
    },*/
    {
      type: 'dateRange',
      startField: 'visit_begin_time',
      endField: 'visit_end_time',
      // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '有效时间范围',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setPerApproval', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '预约单号',
      key: 'application_number',
      dataIndex: 'application_number',
      align: 'left',
    },
    {
      title: '访客姓名',
      key: 'visitor_name',
      dataIndex: 'visitor_name',
      align: 'left',
    },
    {
      title: '访客证件号码',
      key: 'visitor_idcard',
      dataIndex: 'visitor_idcard',
      align: 'left',
    },
    {
      title: '性别',
      key: 'visitor_gender',
      dataIndex: 'visitor_gender',
      align: 'left',
    },
    {
      title: '访客联系电话',
      key: 'visitor_phone',
      dataIndex: 'visitor_phone',
      align: 'left',
    },
    {
      title: '民族',
      dataIndex: 'visitor_nation',
      key: 'visitor_nation',
      align: 'left',
    },
    {
      title: '申请园区',
      dataIndex: 'visit_area',
      key: 'visit_area',
      align: 'left',
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      align: 'left',
      width: 180,
    },
    {
      title: '来访事由',
      dataIndex: 'visit_content',
      key: 'visit_content',
      align: 'left',
      width: 180,
    },
    {
      title: '访客类型',
      dataIndex: 'visitor_type',
      key: 'visitor_type',
      dataInObject: 'personApplication',
      align: 'left',
    },
    {
      title: '被访人员',
      dataIndex: 'interviewee_name',
      key: 'interviewee_name',
      align: 'left',
    },
    {
      title: '被访人联系电话',
      dataIndex: 'interviewee_phone',
      key: 'interviewee_phone',
      align: 'left',
    },
    {
      title: '被访机构',
      dataIndex: 'interviewee_depart_id',
      key: 'interviewee_depart_id',
      align: 'left',
      width: 180,
    },
    {
      title: '审核状态',
      // dataIndex: 'state',
      // key: 'state',
      dataIndex: 'approval_status',
      key: 'approval_status',
      align: 'left',
      width: 130,
    },
    {
      title: '来访时间',
      dataIndex: 'visitor_begin_time',
      key: 'visitor_begin_time',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '220px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showDetailModal(record);
      }
    }
  }

  const cachedSearchParams = computed(() => store.state.search.searchPerApproval)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const canEdit = ref(true)
  const disabled = ref(false)
  const editData = ref(null)

  const showAddModal = () => {
    // editData.value = null
    isEdit.value = false
    disabled.value = false
    canEdit.value = true
    open.value = true
  }
  const showDetailModal = async (data) => {
    loadingRecord.value = data[idField] + 'detail'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      canEdit.value = false
      isEdit.value = true
      disabled.value = true
      open.value = true
    }
  }
  const showEditModal = async (data) => {
    loadingRecord.value = data[idField] + 'edit'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      canEdit.value = true
      isEdit.value = true
      disabled.value = false
      open.value = true
    }
  }

  const showCopyModal = async (data) => {
    loadingRecord.value = data[idField] + 'copy'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = false
      disabled.value = false
      canEdit.value = true
      open.value = true
    }
  }

  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteData({ id: data[idField] })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }

  //5、提交
  async function pushRow(data) {
    const res = await pushData({ id: data[idField] })
    if (res.success) {
      message.success('提交成功！')
      fetch()
    }
  }
  //6、撤销审核
  async function revokeRow() {
    await revokeModalFormRef.value.validate()
    const { id, reason } = revokeModalData.value
    loadingRecord.value = id + 'revoke'
    try {
      const res = await revoke({ id, reason })
      if (res.success) {
        message.success('撤销审核成功！')
        fetch()
        revokeModalOpen.value = false
      } else {
        message.warn('撤销审核失败' + res.message)
      }
    } finally {
      loadingRecord.value = null
    }
  }

  //7、审批流程
  const approvalProcessOpen = ref(false)
  const approvalProcessData = ref()
  async function getApprovalProcess(id) {
    const res = await approvalProcess({ id })
    approvalProcessData.value = res.data
  }
  async function showApprovalProcess(record) {
    loadingRecord.value = record[idField] + 'process'
    await getApprovalProcess(record[idField])
    approvalProcessOpen.value = true
    loadingRecord.value = null
  }

  //8、延期申请
  const extensionRef = ref()
  function showExtension(record) {
    extensionRef.value.openExtension(record[idField])
  }

  const revokeModalFormRef = ref()
  const revokeModalRules = {
    reason: [
      { required: true, message: '请输入撤销理由', trigger: 'blur' }
    ]
  }
  const revokeModalOpen = ref(false)
  const revokeModalData = ref({
    reason: '',
    id: ''
  })
  function showRevokeModal(record) {
    revokeModalData.value = {
      reason: '',
      id: record[idField]
    }
    revokeModalOpen.value = true
  }
</script>
